import { render, staticRenderFns } from "./AdminConfig.vue?vue&type=template&id=234d4bb8&scoped=true"
import script from "./AdminConfig.vue?vue&type=script&lang=js"
export * from "./AdminConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234d4bb8",
  null
  
)

export default component.exports